module.exports = __webpack_public_path__ + "img/Russia.534b86d8.png";